{
  "access": {
    "cannotAdministerUser": "You cannot administer that user.",
    "cannotDisableSelf": "You cannot disable your own account.",
    "cannotGiveRole": "You cannot give anyone the {{role}} role.",
    "contractorCannotBeGranted": "A contractor zone cannot be granted {{areas}}. Remove them, or use a staff zone.",
    "contractorIncludesMineWide": "A contractor zone cannot include a Lead Admin or Super Admin, and this one includes {{users}}. Change their role or move them out first.",
    "contractorMineWideRole": "A Lead Admin or Super Admin cannot belong to a contractor zone. Remove the contractor zone, or choose Admin.",
    "leadAdminResetsPassword": "Only a Lead Admin can reset the password of a user who belongs to more than one zone.",
    "locationNotAdministered": "That location belongs to zones you do not administer.",
    "movementOutsideZones": "This movement belongs to a machine or location outside your zones, so it cannot be changed here.",
    "noGeologyCrushing": "You do not have access to Geology Crushing.",
    "noGeologyRehandle": "You do not have access to Geology Rehandle.",
    "plantAddedElsewhere": "That plant was added by another zone. Only the zone that added it, or the zone that owns it, can change it.",
    "superAdminSetsSubcontractor": "Only a Super Admin can change whether a zone is a subcontractor.",
    "userGone": "That user no longer exists."
  },
  "blasts": {
    "blastReferenceExists": "A blast with reference '{{reference}}' already exists.",
    "blastReferenceExistsAnother": "A blast with reference '{{reference}}' exists for another Blast Pattern.",
    "costCannotNegative": "A cost cannot be negative.",
    "hazardDivisionMostFour": "A hazard division is at most four characters, such as 1.1D.",
    "neqPerUnitMust": "NEQ per unit must be between 0 and 10,000 kg.",
    "packSizeMustMore": "A pack size must be more than zero.",
    "patternChangedSomeoneElse": "This pattern was changed by someone else while you were editing. Refresh to load the latest values, then reapply your change.",
    "patternChargedHoleHole": "This pattern is charged hole by hole, so its usage comes from the holes.",
    "pitStageBelongsPit": "That pit stage belongs to a pit outside your zones.",
    "shelfLifeMustBetween": "Shelf life must be between 0 and 240 months.",
    "unNumberFourDigits": "A UN number is four digits."
  },
  "catalogue": {
    "bitSizeNotExist": "That bit size does not exist.",
    "componentsItemRegisterType": "Components of this item are already on the register, so its type cannot change.",
    "consumableTypeNotExist": "That consumable type does not exist.",
    "costsLivesCannotNegative": "Costs and lives cannot be negative.",
    "partNumberCatalogue": "Part number {{partNumber}} is already in the catalogue.",
    "partNumberDescriptionRequired": "A part number and a description are required.",
    "shelfLifeMustLeast": "A shelf life must be at least a month, or left blank.",
    "stockLevelsCannotNegative": "Stock levels cannot be negative.",
    "trackedOneOneCounted": "{{name}} is tracked one by one, so it is counted in units."
  },
  "charging": {
    "chargeCannotRecordedFuture": "A charge cannot be recorded in the future.",
    "chargeChangedSomeoneElse": "{{holeName}}'s charge was changed by someone else. Refresh, then try again.",
    "countedWhole": "{{blastMaterial}} is counted whole.",
    "enterHowMuchWent": "Enter how much {{blastMaterial}} went in.",
    "giveDepthsCollarTop": "Give {{blastMaterial}}'s depths from the collar, the top before the bottom.",
    "holeTakesMostCharge": "A hole takes at most {{maxLines}} charge lines.",
    "importCharge": "{{hole}}'s charge came from an import, so it is changed there.",
    "importedCharge": "{{hole}}'s charge came from {{system}}, so it is changed there.",
    "numberDecksBottomHole": "Number the decks from 1 at the bottom of the hole."
  },
  "clearance": {
    "giveBearingDegreesDistance": "Give the bearing from 0 to 359 degrees and the distance from 1 to 20,000 m.",
    "giveBothLatitudeLongitude": "Give both the latitude and the longitude, or neither.",
    "nameSentryDescribePost": "Name the sentry or describe the post.",
    "patternClearancePlanStays": "Pattern {{reference}} is {{status}}, so its clearance plan stays as it is.",
    "patternNoOutlineMap": "This pattern has no outline on the map to measure from, so give the sentry's latitude and longitude instead.",
    "positionNotEarthLatitude": "That position is not on the earth: latitude runs from -90 to 90 and longitude from -180 to 180.",
    "postDescribedMostCharacters": "A post is described in at most 200 characters.",
    "sentryChangedSomeoneElse": "This sentry was changed by someone else while you were editing. Refresh, then reapply your change."
  },
  "common": {
    "changedMeanwhile": "Someone else changed this while you were working on it; reload and try again.",
    "savedAtOnce": "Someone else was saving to the same records at that moment; try again."
  },
  "components": {
    "componentNoFitRecord": "That component has no fit on record.",
    "componentNotFittedRig": "That component is not fitted to a rig.",
    "componentTakenOffGoes": "A component taken off goes back to a consumables store.",
    "doesNotFit": "A {{type}} does not fit {{rig}}.",
    "metresHoursCannotNegative": "Metres and hours cannot be negative.",
    "notAwayRegrinding": "{{serialNo}} is not away for regrinding.",
    "notFittedRig": "{{serialNo}} is not fitted to a rig.",
    "notStockCannotFitted": "{{serialNo}} is not in stock, so it cannot be fitted.",
    "regrindGoesRegrindLocation": "A regrind goes to a regrind location.",
    "removalReasonNotExist": "That removal reason does not exist.",
    "sayRegrindLocation": "Say which regrind location it went to.",
    "sayStore": "Say which store it went back to.",
    "sayWhyCameOff": "Say why it came off.",
    "shiftNotRig": "That shift is not this rig's.",
    "someoneElseChangedComponent": "Someone else has changed this component since you opened it; reload and try again."
  },
  "consumables": {
    "addLeastOneItem": "Add at least one item.",
    "adjustmentOneStore": "An adjustment either adds to a store or takes from it.",
    "adminZoneRunsStore": "Only an admin of the zone that runs the store resolves a parked movement.",
    "adminZoneRunsStoreReceives": "Only an admin of the zone that runs the store receives, transfers, adjusts or writes off stock.",
    "componentMovementsCorrectedComponent": "A component's movements are corrected from the component register, not reversed here.",
    "countedWholeUnits": "{{description}} is counted in whole units.",
    "dBAdminEnters": "Only a D&B admin enters a price. Leave it blank and the catalogue cost is used.",
    "giveReasonDiscardingKept": "Give the reason for discarding it; it is kept with the movement.",
    "giveReasonKeptLedger": "Give the reason; it is kept on the ledger.",
    "giveReasonReversalKept": "Give the reason for the reversal; it is kept on the ledger.",
    "giveSerialEachReceived": "Give a serial for each of the {{quantity, whole}} {{description}} received.",
    "issueRigReturnOne": "Only an issue to a rig or a return from one is recorded here.",
    "lotTrackedLotMust": "{{description}} is lot-tracked, so its lot must be recorded.",
    "movementCannotRecordedFuture": "A movement cannot be recorded in the future.",
    "movementResolved": "That movement has already been resolved.",
    "movementReversed": "That movement has already been reversed.",
    "outOfStore": "This movement comes out of a store.",
    "postedMovementCanReversed": "Only a posted movement can be reversed.",
    "quantityMustMoreZero": "The quantity of {{description}} must be more than zero.",
    "receiptIntoStore": "A receipt goes into a store.",
    "regrindsStocktakesReversalsOwn": "Regrinds, stocktakes and reversals have their own forms.",
    "returnIntoStore": "A return from a rig goes back into a store.",
    "reversalStocktakeCannotReversed": "A reversal or a stocktake cannot be reversed; record the movement again instead.",
    "sayRigShiftIssue": "Say which rig and shift the issue went to.",
    "serialAppearsTwiceReceipt": "A serial appears twice on this receipt.",
    "serialsOnRegister": "{{item}} {{serials}} is already on the register.",
    "someReceiptIssuedReverse": "Some of that receipt has already been issued; reverse those issues first.",
    "trackedOneOneFit": "{{description}} is tracked one by one; fit, regrind and remove it from the component register.",
    "transferBetweenStores": "A transfer goes from one store to another."
  },
  "designImport": {
    "addHoleTypeBefore": "Add a hole type before importing a design.",
    "chooseColumnHoldsHole": "Choose the column that holds the hole name.",
    "fileNoColumn": "The file has no column {{value}}.",
    "fileNoHeaderRow": "The file has no header row.",
    "fileNoHoles": "The file has no holes.",
    "firedClosedCancelledPattern": "A fired, closed or cancelled pattern's design cannot be replaced.",
    "holeNameLongerCharacters": "Hole {{name}} has a name longer than 20 characters.",
    "mappingNameMostCharacters": "A mapping name is at most 60 characters."
  },
  "digging": {
    "blastMasterPatternBlast": "Blast Master and Pattern Blast must both be set.",
    "bothPatternblastidBlastmasteridMust": "Both PatternBlastId and BlastMasterId must be set.",
    "diggingPatternOutsideYour": "This digging pattern is outside your zones, so its loads cannot be checked here.",
    "loadBelongsTruckDestination": "This load belongs to a truck or destination outside your zones, so it cannot be changed here.",
    "noBlastPatternFound": "No Blast Pattern found for BlastMasterId {{blastMasterId}} in your selected Pit Stage",
    "noBlastmasterForPattern": "No Blastmaster found for Pattern Blast {{pattern}}",
    "noBlastmasterFoundPatternblastid": "No BlastMaster found for PatternBlastId {{patternBlastId}}",
    "truckLoadChangedSomeone": "This truck load was changed by someone else while you were editing. Refresh to load the latest values, then reapply your change.",
    "uncheckedOutsideZones_one": "{{count}} unchecked load in this hour belongs to a truck or destination outside your zones, so only someone in that zone can check it.",
    "uncheckedOutsideZones_other": "{{count}} unchecked loads in this hour belong to a truck or destination outside your zones, so only someone in that zone can check them."
  },
  "dipping": {
    "backfillMustLessDepth": "Backfill must be less than the depth of the hole.",
    "dipCannotRecordedFuture": "A dip cannot be recorded in the future.",
    "dipChangedSomeoneElse": "This dip was changed by someone else. Refresh, then try again.",
    "enterDepthDippedMetres": "Enter the depth dipped, in metres.",
    "waterCannotDeeperHole": "The water cannot be deeper than the hole."
  },
  "drilling": {
    "bitSizeNotExist": "That bit size does not exist.",
    "chooseBitSize": "Choose the bit size.",
    "drilledHoleChangedSomeone": "This drilled hole was changed by someone else. Refresh, then try again.",
    "enterDepthDrilledMetres": "Enter the depth drilled, in metres.",
    "patternCanNoLonger": "Pattern {{reference}} is {{status}} and can no longer be drilled.",
    "patternNoHolesYet": "The pattern has no holes yet. Import its design, or add holes, before recording hole by hole.",
    "patternRecordedSummaryShift": "This pattern is recorded in summary on this shift, so it takes summary lines rather than drilled holes.",
    "removeRecordedPatternShift": "Remove what is recorded for this pattern on this shift before changing how it is recorded."
  },
  "drillingRecords": {
    "lineChangedSomeoneElse": "This line was changed by someone else while you were editing. Refresh to load the latest values, then reapply your change.",
    "patternCanNoLonger": "Pattern {{reference}} is {{status}} and can no longer be drilled.",
    "patternNoHolesYet": "Pattern {{reference}} has no holes yet, so it is recorded in summary.",
    "patternPitOutsideYour": "That pattern is in a pit outside your zones.",
    "patternRecordedHoleHole": "This pattern is recorded hole by hole on this shift, so it takes drilled holes rather than summary lines.",
    "removeHolesDrilledPattern": "Remove the holes drilled on this pattern first."
  },
  "explosives": {
    "addLeastOneProduct": "Add at least one product.",
    "adjustmentOneStore": "An adjustment adds to or takes from one store.",
    "blastPitOutsideYour": "That blast is in a pit outside your zones.",
    "chooseBlastExplosives": "Choose the blast the explosives are for.",
    "countedWholeUnits": "{{blastMaterial}} is counted in whole units.",
    "destructionNeedsWitness": "A destruction needs a witness.",
    "destructionOutOfStore": "A destruction takes stock out of a store, or names the blast it was issued to when destroyed on the bench.",
    "giveReasonAdjustmentKept": "Give the reason for the adjustment; it is kept on the register.",
    "giveReasonDiscardingKept": "Give the reason for discarding it; it is kept with the movement.",
    "giveReasonReversalKept": "Give the reason for the reversal; it is kept on the register.",
    "issueOutOfStore": "An issue takes stock out of a store.",
    "issuesReturnsBenchDestructions": "Only issues, returns and bench destructions are recorded against a blast.",
    "movementCannotRecordedFuture": "A movement cannot be recorded in the future.",
    "movementResolved": "That movement has already been resolved.",
    "movementReversed": "That movement has already been reversed.",
    "movementTouchesStoreRun": "That movement touches a store run by a zone you are not in.",
    "postedMovementCanReversed": "Only a posted movement can be reversed.",
    "quantityMustMoreZero": "The quantity of {{blastMaterial}} must be more than zero.",
    "receiptIntoStore": "A receipt puts stock into a store.",
    "returnIntoStore": "A return puts stock back into a store.",
    "reversalCannotItselfReversed": "A reversal cannot itself be reversed; record the movement again instead.",
    "runZoneYouNot": "{{name}} is run by a zone you are not in, so you cannot record movements there.",
    "stocktakesReversalsOwnForms": "Stocktakes and reversals have their own forms.",
    "takingStockOffRegister": "Taking stock off the register needs a witness.",
    "transferBetweenStores": "A transfer moves stock between two different stores."
  },
  "firing": {
    "bearingRunsDegrees": "A bearing runs from 0 to 359 degrees.",
    "blastFinalFiring": "This blast already has a final firing.",
    "finalFiringNeedsTime": "The final firing needs the time it was fired.",
    "firingCannotRecordedFuture": "A firing cannot be recorded in the future.",
    "firingChangedSomeoneElse": "This firing was changed by someone else while you were editing. Refresh, then reapply your change.",
    "firingRecordedOnceBlast": "A firing is recorded once the blast is being charged.",
    "fumeRatingsRun": "Fume ratings run from 0 to 5.",
    "misfireCannotClearedBefore": "A misfire cannot be cleared before it was found.",
    "misfireChangedSomeoneElse": "This misfire was changed by someone else. Refresh, then try again.",
    "misfireCleared": "That misfire has already been cleared.",
    "misfireReportedAfterBlast": "A misfire is reported after the blast has been fired.",
    "nameShotfirer": "Name the shotfirer.",
    "recordCircuitTest": "Record the circuit test.",
    "recordExclusionZone": "Record the exclusion zone.",
    "recordMic": "Record the maximum instantaneous charge.",
    "recordNearestStructure": "Record the distance to the nearest structure.",
    "recordSentries": "Record how many sentries were posted.",
    "recordWeather": "Record the weather.",
    "shotfirerUnlicensed": "The shotfirer holds no current shotfirer or blast controller licence."
  },
  "fragmentation": {
    "fragmentationSurveyedOnceBlast": "Fragmentation is surveyed once the blast has been fired.",
    "giveLeastOneSize": "Give at least one size, or the share of oversize.",
    "giveSizeOverRock": "Give the size over which a rock counts as oversize.",
    "oversizePercentage": "Oversize is a percentage, from 0 to 100.",
    "p50P80P90Top": "P50, P80, P90 and the top size grow in that order.",
    "sayHowBlastSurveyed": "Say how the blast was surveyed.",
    "sizesMillimetresMoreMost": "Sizes are in millimetres, more than 0 and at most 100,000.",
    "surveyCannotComeBefore": "A survey cannot come before the blast, on {{blasted, date}}.",
    "surveyCannotDatedFuture": "A survey cannot be dated in the future.",
    "surveyChangedSomeoneElse": "This survey was changed by someone else while you were editing. Refresh, then reapply your change."
  },
  "gcDrilling": {
    "choosePitStageLocation": "Choose the pit stage or location drilled.",
    "holesMustMoreZero": "Holes must be more than zero.",
    "lineChangedSomeoneElse": "This line was changed by someone else while you were editing. Refresh to load the latest values, then reapply your change.",
    "metresMustMoreZero": "Metres must be more than zero.",
    "notRcRig": "{{plantRef}} is not an RC rig.",
    "pitOutsideYourZones": "That pit is outside your zones.",
    "programmeReferenceLimitedCharacters": "The programme reference is limited to 30 characters.",
    "rcDrillingShift": "{{plantRef}} already has RC drilling in this shift.",
    "samplesCannotNegative": "Samples cannot be negative.",
    "unknownDrillingType": "Unknown drilling type.",
    "unknownPitStage": "Unknown pit stage."
  },
  "geology": {
    "entryChangedSomeoneElse": "This entry was changed by someone else while you were editing. Refresh to load the latest values, then reapply your change.",
    "pleaseSelectHourWithin": "Please select an hour within the shift.",
    "pleaseSelectTimeWithin": "Please select a time within the shift.",
    "selectPlantModel": "Please select a Plant Model.",
    "selectTruck": "Please select a Truck.",
    "truckNotAvailableShift": "That truck is not available on this shift. Please select another."
  },
  "holes": {
    "chargeOffDesign": "{{hole}} has {{charge, upto2}} m of charge against {{design, upto2}} m designed, outside the {{tolerance, upto2}} m tolerance.",
    "chargedBelowDip": "{{hole}} is charged to {{deepest, upto2}} m, below the {{dipped, upto2}} m it dipped.",
    "designDuplicate": "Hole {{hole}} appears more than once; the first row was used.",
    "designKept_one": "{{count}} hole not in the file was kept, because drilling, dipping or charging is recorded against it, or it is on an issued sheet.",
    "designKept_other": "{{count}} holes not in the file were kept, because drilling, dipping or charging is recorded against them, or they are on an issued sheet.",
    "designRowNoName": "Row {{row}} has no hole name and was skipped.",
    "designUnknownDiameters": "No bit size matches {{diameters}}; those holes have no design bit size.",
    "designUnknownTypes": "Hole types not in Eclipse were imported as {{type}}: {{types}}.",
    "dipTooOld": "{{hole}} was last dipped {{age, whole}} hours before charging, more than the {{limit, whole}} hour limit.",
    "dippedPastDesign": "{{hole}} dipped at {{depth, upto2}} m is {{gap, upto2}} m past its {{reference, upto2}} m design, outside the {{tolerance, upto2}} m tolerance. Choose backfill if it needs one.",
    "dippedPastDrilled": "{{hole}} dipped at {{depth, upto2}} m is {{gap, upto2}} m past its {{reference, upto2}} m drilled depth, outside the {{tolerance, upto2}} m tolerance. Choose backfill if it needs one.",
    "dippedShortOfDesign": "{{hole}} dipped at {{depth, upto2}} m is {{gap, upto2}} m short of its {{reference, upto2}} m design, outside the {{tolerance, upto2}} m tolerance. Choose clean out or redrill if it needs one.",
    "dippedShortOfDrilled": "{{hole}} dipped at {{depth, upto2}} m is {{gap, upto2}} m short of its {{reference, upto2}} m drilled depth, outside the {{tolerance, upto2}} m tolerance. Choose clean out or redrill if it needs one.",
    "drilledPast": "{{hole}} at {{depth, upto2}} m is {{gap, upto2}} m past its {{design, upto2}} m design, outside the {{tolerance, upto2}} m tolerance.",
    "drilledShort": "{{hole}} at {{depth, upto2}} m is {{gap, upto2}} m short of its {{design, upto2}} m design, outside the {{tolerance, upto2}} m tolerance.",
    "giveHoleName": "Give the hole a name.",
    "holeNameMostCharacters": "A hole name is at most 20 characters.",
    "holePositionNeedsBoth": "A hole's position needs both its easting and its northing.",
    "holeTypeNotExist": "That hole type does not exist.",
    "noDip": "{{hole}} has no dip.",
    "patternCanNoLonger": "Pattern {{reference}} is {{status}} and can no longer be {{doneTo}}.",
    "patternFrozen": "The pattern is {{status}}, so its holes can no longer change.",
    "patternHole": "The pattern already has a hole {{name}}.",
    "stemmingOffDesign": "{{hole}} has {{stemming, upto2}} m of stemming against {{design, upto2}} m designed, outside the {{tolerance, upto2}} m tolerance."
  },
  "iredes": {
    "failedAtDepth_one": "The rig failed {{holes}} at full depth, so it is recorded abandoned; check with the driller and change the outcome if the hole is good.",
    "failedAtDepth_other": "The rig failed {{holes}} at full depth, so they are recorded abandoned; check with the driller and change the outcome if the hole is good.",
    "fileDrillPlanImport": "That file is a drill plan. Import the quality report the rig wrote after drilling.",
    "fileNotIredesQuality": "That file is not an IREDES quality report (its root is {{localName}}).",
    "fileNotReadableXml": "The file is not readable XML: {{message}}",
    "inSummary": "{{pattern}} is recorded in summary on {{rig}}'s shift {{shift}}, so its {{holes}} holes there were left out.",
    "noBitSize": "{{hole}} has no bit size the report's {{diameter}} mm matches, so it was left out.",
    "noOperation": "{{rig}} has no operation on shift {{shift}}, so its {{holes}} holes there were left out; enter the shift, then import again.",
    "notOnPattern_one": "{{count}} hole in the report is not on {{pattern}}: {{holes}}.",
    "notOnPattern_other": "{{count}} holes in the report are not on {{pattern}}: {{holes}}.",
    "otherPlan": "The report is for plan {{plan}}, not {{pattern}}; its holes were matched by number and name.",
    "otherRig": "The report came from {{equipment}}, not {{rig}}.",
    "patternRecordedSummaryShift": "This pattern is recorded in summary on this shift. Record it hole by hole to import the rig's report.",
    "reportNoDrilledHoles": "The report has no drilled holes in it.",
    "statusOthers_one": "The rig gave {{holes}} the status Others, so it is recorded complete; check with the driller.",
    "statusOthers_other": "The rig gave {{holes}} the status Others, so they are recorded complete; check with the driller.",
    "untimed_one": "{{count}} hole has no time in a shift {{rig}} works, so it was left out.",
    "untimed_other": "{{count}} holes have no time in a shift {{rig}} works, so they were left out."
  },
  "keys": {
    "labelRequired": "Label is required.",
    "sourceSystemRequired": "Source system is required."
  },
  "lookups": {
    "alreadyCalled": "There is already a {{kind}} called {{name}}.",
    "bitDiameter": "A bit's diameter is between 25 and 400 mm.",
    "bitSize": "bit size",
    "blastType": "blast type",
    "chooseBlastTypeCategory": "Choose the blast type's category.",
    "chooseHoleTypeCategory": "Choose the hole type's category.",
    "giveName": "Give the {{kind}} a name.",
    "holeType": "hole type",
    "keepOneInUse": "Keep at least one {{kind}} in use.",
    "mineAdminsOnly": "These lists are the whole mine's, so only the mine's own admins change them.",
    "nameTooLong": "A {{kind}}'s name is at most {{maxLength}} characters.",
    "orderRange": "The order is a number from 0 to {{max}}.",
    "removalReason": "removal reason",
    "retiredCalled": "There is already a retired {{kind}} called {{name}}; bring that one back into use instead."
  },
  "magazines": {
    "explosivesLoadingUnitCan": "Only an explosives loading unit can carry a store.",
    "licensedNeqCannotNegative": "The licensed NEQ cannot be negative.",
    "magazineCanGivenZone": "A magazine can only be given to a zone you are in.",
    "magazineChangedSomeoneElse": "This magazine was changed by someone else while you were editing. Refresh, then reapply your change.",
    "mmuStoreMustName": "An MMU store must name the MMU it is on.",
    "nameRequired": "A name is required.",
    "notKindExplosivesStore": "That is not a kind of explosives store.",
    "storeCalled": "There is already a store called {{name}}.",
    "zoneNotExist": "That zone does not exist.",
    "zoneRunsMagazineLead": "Only the zone that runs this magazine, or a Lead Admin, can change it."
  },
  "monitoring": {
    "airblastDbL": "Airblast is in dB(L), from 0 to 200.",
    "distanceMustM": "The distance must be from 0 to 999,999 m.",
    "givePpvAirblastBoth": "Give the PPV, the airblast, or both.",
    "importedReading": "This reading came from {{system}}, so it stays as the monitor recorded it.",
    "monitorReading": "This reading came from the monitor, so it stays as the monitor recorded it.",
    "notesMostCharacters": "Notes are at most 500 characters.",
    "ppvFrequencyMust": "The PPV and frequency must be from 0 to 9,999.",
    "readingCannotRecordedFuture": "A reading cannot be recorded in the future.",
    "readingChangedSomeoneElse": "This reading was changed by someone else while you were editing. Refresh, then reapply your change.",
    "readingFiringRecordedWithin": "A reading for this firing is recorded within {{readingWindowHours}} hours of it.",
    "readingRecordedOnceFiring": "A reading is recorded once the firing has been fired.",
    "retiredTakesNoNew": "{{name}} is retired, so it takes no new readings."
  },
  "monitors": {
    "absoluteMaximumCannotBelow": "The absolute maximum cannot be below the limit.",
    "allowedExceedancePercentage": "The allowed exceedance is a percentage, from 0 to 100.",
    "alreadyJudged": "Blasts up to {{last, date}} have already been judged against the {{metric}} limit, so a new one starts after that day.",
    "blastsJudgedLimitStays": "Blasts have already been judged by this limit, so it stays as it is. Add a new limit from a later day instead.",
    "choosePpvAirblastWindow": "Choose PPV or airblast, and the window it is judged over.",
    "giveBothLatitudeLongitude": "Give both the latitude and the longitude, or neither.",
    "licenceLimitsMineOwn": "The licence limits are the mine's, so only its own staff change them.",
    "limitChangedSomeoneElse": "This limit was changed by someone else while you were editing. Refresh, then reapply your change.",
    "limitExists": "There is already a {{metric}} limit from {{from, date}}.",
    "limitMustMoreNothing": "The limit must be more than nothing.",
    "monitorCalled": "There is already a monitor called {{name}}.",
    "monitorChangedSomeoneElse": "This monitor was changed by someone else while you were editing. Refresh, then reapply your change.",
    "monitorTaggedPitOutside": "That monitor is tagged to a pit outside your zones.",
    "nameRequired": "A name is required.",
    "nameSerialNumberMake": "A name, serial number and make are each at most 50 characters.",
    "pitOutsideYourZones": "That pit is outside your zones.",
    "positionNotEarthLatitude": "That position is not on the earth: latitude runs from -90 to 90 and longitude from -180 to 180.",
    "sayHowManyLatest": "Say how many of the latest blasts the window covers, from 1 to 1,000.",
    "tagMonitorOneYour": "Tag the monitor to one of your pits."
  },
  "patterns": {
    "bitSizeNotExist": "That bit size does not exist.",
    "cannotMove": "A pattern that is {{from}} cannot be moved to {{to}}.",
    "clearMisfires": "Clear them before closing it.",
    "drillingStays": "{{metres, n1}} m of drilling stays recorded against it.",
    "giveDatePatternFired": "Give the date the pattern was fired.",
    "giveReasonClosingPatterns": "Give a reason for closing these patterns; it is kept with the change.",
    "materialDescriptionMustCharacters": "Material description must be 100 characters or fewer.",
    "mustBetween": "{{name}} must be between {{min, upto2}} and {{max, upto2}}.",
    "openMisfires": "{{misfires}} misfires on this pattern are still open.",
    "outsideZones": "That pattern belongs to a pit outside your zones.",
    "patternChangedSomeoneElse": "This pattern was changed by someone else while you were editing. Refresh to load the latest values, then reapply your change.",
    "patternFiringRecordMarked": "This pattern has a firing record, so it is marked fired when its final firing is saved.",
    "signOffVariances": "An admin signs off each variance on the Explosives tab before the blast can close.",
    "stemmingMaterialMustCharacters": "Stemming material must be 30 characters or fewer.",
    "undrilled": "{{holes}} designed holes are neither drilled nor abandoned.",
    "unreconciled": "The explosives do not reconcile: {{variances}}.",
    "variance": "{{material}}: {{variance, upto3}} {{unit}} unaccounted for"
  },
  "personnel": {
    "contractorZonePeopleBelong": "A contractor zone's people belong to its zone; the mine's own are kept by the mine.",
    "employeeNumberUsedSomeone": "Employee number {{employeeNo}} is already used by someone else.",
    "licenceCannotExpireBefore": "A licence cannot expire before it was issued.",
    "licenceChangedSomeoneElse": "This licence was changed by someone else while you were editing. Refresh, then reapply your change.",
    "licenceNumberRequired": "A licence number is required.",
    "nameRequired": "A name is required.",
    "personBelongsZoneYou": "That person belongs to a zone you are not in.",
    "personChangedSomeoneElse": "This person was changed by someone else while you were editing. Refresh, then reapply your change.",
    "youCanAttachPeople": "You can only attach people to a zone you are in.",
    "zoneNotExist": "That zone does not exist."
  },
  "reconciliation": {
    "giveReasonVarianceAppears": "Give the reason for the variance; it appears on the blast record.",
    "noVarianceWaitingSign": "{{material}} has no variance waiting for sign-off.",
    "varianceSignedOffDrill": "A variance is signed off by a drill and blast admin of the zone that runs the issuing magazine, or by a Lead Admin."
  },
  "records": {
    "blastPatternInUse": "Failed to delete blast pattern. It may have related entries.",
    "dateFromBeforeDateTo": "DateFrom must be before DateTo.",
    "demoStopLimit": "On the demo you can stop up to {{machines}} machines at once.",
    "dewateringInUse": "Unable to delete dewatering record. Please ensure it is not in use.",
    "feedbackRequired": "Feedback is required.",
    "miningMovementNotFound": "Geology mining movement not found",
    "periodInUse": "Failed to delete period. It may be in use.",
    "reportNotFound": "Report not found.",
    "shiftDoesNotExist": "Shift does not exist.",
    "shiftNotFound": "Shift not found",
    "shiftNotFoundCheckDate": "The specified shift does not exist. Please check the date and shift type.",
    "stoppageNotFound": "Stoppage not found",
    "targetInUse": "Failed to delete target. It may be in use.",
    "targetTypeNotFound": "Target type not found.",
    "templateNotFound": "Template {{id}} not found.",
    "truckLoadNotFound": "Truck load not found.",
    "userDoesNotExist": "User does not exist."
  },
  "references": {
    "locationIdNotFound": "Location with id {{id}} was not found.",
    "plantMustExactlyOne": "A plant must have exactly one job type.",
    "plantReferenceExists": "A plant with reference \"{{plantRef}}\" already exists.",
    "shiftHoursAllowed": "Shift Hours must be {{allowed}}.",
    "zoneStillHas": "{{zone}} still has {{uses}}. Move or remove those first."
  },
  "reports": {
    "crusherFeed": "Crusher Feed",
    "crusherFeedRow": "{{material}} from {{from}}",
    "crusherFeedTotal": "Crusher feed total",
    "dewatering": "Dewatering",
    "materialTotal": "{{material}} total",
    "rehandle": "Rehandle",
    "rehandleRow": "{{material}} from {{from}} to {{to}}",
    "rehandleTotal": "Rehandle total"
  },
  "rigs": {
    "alsoInDailyTotals": "Geology's daily drilling totals also have this type for this pit on this date, so both are counted.",
    "endBelowStart": "The end reading is lower than the start. Tick \"meter replaced\" if the meter was changed.",
    "longerThanShift": "{{hours, fixed1}} h is longer than the {{shiftHours}} h shift.",
    "meterChangedSomeoneElse": "This meter was changed by someone else while you were editing. Refresh to load the latest reading, then reapply your change.",
    "meterReadingCannotNegative": "A meter reading cannot be negative.",
    "metresOverRig": "{{metres, upto1}} m is more than {{rig}} drilled while {{serial}} was fitted ({{rigMetres, upto1}} m).",
    "noMeter": "{{plantRef}} has no {{meterType}} meter.",
    "outsideZones": "That rig belongs to a zone outside yours, so its drilling cannot be changed here.",
    "percussionOverEngine": "{{hours, fixed1}} percussion hours is more than the {{engine, fixed1}} engine hours.",
    "serviceIntervalMustMore": "A service interval must be more than zero hours.",
    "setMeterPlantBefore": "Set up this meter on the plant before recording a service.",
    "unknownMeterType": "Unknown meter type."
  },
  "royalties": {
    "blastmasterIdExists": "A Blastmaster with this ID already exists",
    "leastOneAreaPercentage": "At least one area with a percentage greater than zero is required",
    "noHeaderRow": "Could not auto-detect the header row. Please specify a starting cell (e.g. CG1).",
    "noRoyaltyAreaColumns": "No Royalty Area columns found in the header row.",
    "noSheetsFoundWorkbook": "No sheets found in workbook.",
    "notValidXlsxFile": "Not a valid xlsx file (xl/workbook.xml not found).",
    "rowAreaBlastmasterExists": "A row for this Area and BlastMaster already exists.",
    "sheetNotFoundWorkbook": "Sheet \"{{sheetName}}\" not found in the workbook.",
    "unknownColumn": "Column header \"{{header}}\" does not match any known Royalty Area and was skipped.",
    "worksheetContainsNoData": "Worksheet contains no data."
  },
  "settings": {
    "giveReasonTurningOff": "Give a reason for turning off \"{{label}}\"; it is kept with the change.",
    "leadAdminCanChange": "Only a Lead Admin can change {{label}}, because it changes figures already reported.",
    "mineDrillBlastSettings": "The mine's drill and blast settings are changed by its own admins, not by a contractor zone's.",
    "mustBeOneOf": "{{label}} must be one of {{choices}}.",
    "mustBetween": "{{label}} must be between {{min}} and {{max}}.",
    "mustNumber": "{{label}} must be a number.",
    "notBlockWarnOff": "{{mode}} is not Block, Warn or Off.",
    "surveyGridMustEpsg": "The survey grid must be an EPSG code such as EPSG:32647, or Local.",
    "tooLong": "{{label}} is too long."
  },
  "sheets": {
    "abandonedNotIssued_one": "{{holes}} is abandoned, so not issued.",
    "abandonedNotIssued_other": "{{holes}} are abandoned, so not issued.",
    "alreadyOnSheet_one": "{{holes}} is already on open sheet {{sheet}}; close it or leave them off.",
    "alreadyOnSheet_other": "{{holes}} are already on open sheet {{sheet}}; close it or leave them off.",
    "chooseDrillDipCharge": "Choose a drill, dip or charge sheet.",
    "chooseHolesSheet": "Choose the holes the sheet is for.",
    "dipChargeSheetsHandled": "Dip and charge sheets are handled on the pattern page.",
    "dipLoadingSheetsPrinted": "Dip and loading sheets are printed from the pattern page.",
    "patternNoSheetCan": "Pattern {{reference}} is {{status}}, so no sheet can be {{doneTo}} for it.",
    "patternOpenSheetCalled": "Pattern {{reference}} already has an open sheet called {{name}}.",
    "personNotFound": "That person was not found.",
    "sheetChangedSomeoneElse": "Sheet {{name}} was changed by someone else. Refresh, then try again.",
    "sheetClosed": "Sheet {{name}} is already closed.",
    "sheetNameMostCharacters": "A sheet's name is at most 50 characters.",
    "someHolesNotPattern": "Some of those holes are not on pattern {{reference}}."
  },
  "stock": {
    "blastClosed": "Explosives cannot be issued to a blast that has been closed or cancelled.",
    "blastFired": "Explosives cannot be issued to a blast after it has been fired.",
    "consumableLotExpired": "Lot {{lot}} of {{item}} passed its use-by date on {{date, date}}.",
    "explosiveLotExpired": "Lot {{lot}} of {{material}} expired on {{date, date}}.",
    "heldThen": "{{location}} held {{held, upto3}} of {{material}} at {{at, time}}, so {{quantity, upto3}} cannot have left it then.",
    "heldThenInLot": "{{location}} held {{held, upto3}} of {{material}} in that lot at {{at, time}}, so {{quantity, upto3}} cannot have left it then.",
    "heldTooLittle": "{{store}} held {{held, upto3}} of {{item}} when {{quantity, upto3}} left it, so the ledger would go below zero.",
    "heldTooLittleInLot": "{{store}} held {{held, upto3}} of {{item}} in that lot when {{quantity, upto3}} left it, so the ledger would go below zero.",
    "holdsNow": "{{location}} holds {{held, upto3}} of {{material}}, so {{quantity, upto3}} cannot leave it.",
    "holdsNowInLot": "{{location}} holds {{held, upto3}} of {{material}} in that lot, so {{quantity, upto3}} cannot leave it.",
    "lotNotRecorded": "{{material}} is lot-tracked, so its lot should be recorded.",
    "nameRecipient": "Name the shotfirer receiving or returning the explosives.",
    "neqOver": "{{location}} would hold {{neq, n1}} kg NEQ, over its licensed {{licensed, n1}} kg.",
    "neqOverBy": "{{location}} would hold {{neq, n1}} kg NEQ by {{at, time}}, over its licensed {{licensed, n1}} kg.",
    "noLongerInUse": "{{location}} is no longer in use, so nothing can be put into it.",
    "notEnoughHeld": "{{store}} did not hold enough {{item}} for {{quantity, upto3}} to leave it, so the ledger would go below zero.",
    "notEnoughHeldInLot": "{{store}} did not hold enough {{item}} in that lot for {{quantity, upto3}} to leave it, so the ledger would go below zero.",
    "notEnoughInDate": "There is not enough {{item}} in date to issue {{quantity, upto3}}; the rest is past its use-by date.",
    "notEnoughInStore": "There is not enough {{item}} in that store to issue {{quantity, upto3}}.",
    "notLicensedFor": "{{location}} is not licensed to hold {{storageClass}} products such as {{material}}.",
    "overReturn": "The rig holds {{held, upto3}} {{item}} from its issues, so {{returning, upto3}} cannot come back.",
    "recipientUnlicensed": "The person receiving this issue holds no current shotfirer or blast controller licence.",
    "recordCertificate": "Record the destruction certificate number.",
    "recordDocket": "Record the delivery docket number.",
    "takingLeavesShort": "Taking {{quantity, upto3}} of {{material}} out of {{location}} at {{at, time}} would leave it at {{left, upto3}} by {{by, time}}.",
    "takingLeavesShortInLot": "Taking {{quantity, upto3}} of {{material}} in that lot out of {{location}} at {{at, time}} would leave it at {{left, upto3}} by {{by, time}}."
  },
  "stocktakes": {
    "addCommentKeptStocktake": "Add a comment; it is kept with the stocktake.",
    "adminCanApproveStocktake": "Only an admin can approve a stocktake.",
    "countCannotNegative": "A count cannot be negative.",
    "magazineRunZoneYou": "That magazine is run by a zone you are not in.",
    "noPackSizeCount": "{{blastMaterial}} has no pack size, so count it in units.",
    "stocktakeChangedSomeoneElse": "This stocktake was changed by someone else. Refresh, then try again.",
    "stocktakeNoLongerWaiting": "That stocktake is no longer waiting for approval.",
    "trackedOneOneComponent": "{{description}} is tracked one by one on the component register, not counted here."
  },
  "stoppages": {
    "someoneCheckedStoppage": "Someone has already checked this stoppage.",
    "stoppageStillSettledFms": "This stoppage is still being settled by the FMS.",
    "subTypeNotBelong": "That sub type does not belong to the chosen stoppage type."
  },
  "stores": {
    "consumablesStoreEitherStore": "A consumables store is either a store or a regrind location.",
    "nameRequired": "A name is required.",
    "storeCalled": "There is already a store called {{name}}.",
    "storeCanGivenZone": "A store can only be given to a zone you are in.",
    "zoneNotExist": "That zone does not exist."
  },
  "survey": {
    "controlPointChangedSomeone": "This control point was changed by someone else. Refresh, then try again.",
    "controlPointsAllSit": "The control points all sit on one grid position.",
    "epsgNotGridEclipse": "EPSG:{{code}} is not a grid Eclipse converts yet; use a UTM zone, Indian 1975 47N or 48N, or Local.",
    "giveControlPointName": "Give the control point a name of up to 50 characters.",
    "latitudeLongitudeNotEarth": "That latitude or longitude is not on the Earth.",
    "leadAdminSetsSurvey": "Only a Lead Admin sets the survey grid, because it moves every hole on the map.",
    "surveyGridNotEpsg": "The survey grid {{value}} is not an EPSG code or Local."
  },
  "targetImport": {
    "excelMissingExpectedColumn": "Excel is missing expected column header '{{header}}'.",
    "excludedByPattern": "Row {{row}}: excluded by pattern (\"{{label}}\")",
    "headerChanged": "Column {{column}}: header changed from \"{{from}}\" to \"{{to}}\". Mapping still applies by column index; review the template if this is unexpected.",
    "labelChanged": "Row {{row}}: label changed from \"{{from}}\" to \"{{to}}\". Mapping will still apply by row index. Review the template if this is unexpected.",
    "noColumnMappings": "No column mappings are configured on this template. At least one mapping is required for RowBased imports.",
    "noDateColumns": "No date columns could be parsed from the configured date header row. Check DateRowIndex and DateSource on the template.",
    "noParsableDate": "Row {{row}}: no parsable date value (DateSource={{source}})",
    "noRowMapping": "Row {{row}}: no column mapping for row index {{index}} (\"{{label}}\") — row skipped",
    "rowLabelChanged": "Row {{row}}: row label changed from \"{{from}}\" to \"{{to}}\". Mapping still applies by row index; review the template if this is unexpected.",
    "rowLabelSource": "{{name}} source is Row Label on the row label column, so every metric row is looked up as a {{lowerName}} and each one that is not will be reported as unmatched. Set the {{lowerName}} source to Not Applicable and pin it on the column mappings that need it.",
    "sectionLabelDiffers": "Row {{row}}: section label in file is \"{{label}}\" but template has \"{{saved}}\". Using saved configuration.",
    "unknownOrientation": "Unknown ValueOrientation ({{orientation}}). Template cannot be parsed.",
    "unsectionedRow": "Row {{row}}: \"{{label}}\" has no values and matches no section, so the mapped rows below it are read as \"{{section}}\". Add a section for it if those rows belong somewhere else."
  },
  "targets": {
    "bandNeedsToleranceAbove": "A band needs a tolerance above zero, as a percentage either side of target.",
    "dateMustBeforeDate": "Date From must be before Date To",
    "duplicateTarget": "A target with the same category, type, date and scope already exists.",
    "pitStageNotExist": "Pit stage {{value}} does not exist.",
    "systemTargetTypesCannot": "System target types cannot be modified.",
    "systemTargetTypesCannotDeleted": "System target types cannot be deleted.",
    "targetsCardNoActual": "The targets card has no actual for {{name}}, so it cannot show it."
  },
  "telemetryImport": {
    "aheadOfClock": "Row {{rowNumber}} in '{{fileName}}' has a timestamp_utc of {{timestamp}}, ahead of the server clock.",
    "csvTelemetryFilesAccepted": "Only .csv telemetry files are accepted.",
    "fileBytesExceedingByte": "File is {{length}} bytes, exceeding the {{maxFileSizeBytes}}-byte limit.",
    "noFileUploaded": "No file was uploaded.",
    "noWorkDate": "Could not determine the work date for '{{fileName}}'. Expected a date in the file name, or a 'Latest Utilization Report' column.",
    "rowEndtimeBeforeStarttime": "Row {{rowNumber}} in '{{fileName}}' has an EndTime before its StartTime.",
    "rowInvalidEndtime": "Row {{rowNumber}} in '{{fileName}}' has an invalid EndTime '{{endRaw}}'.",
    "rowMissingValid": "Row {{rowNumber}} in '{{fileName}}' is missing a valid {{header}}.",
    "rowMissingValidStarttime": "Row {{rowNumber}} in '{{fileName}}' is missing a valid StartTime.",
    "rowMissingValidTimestamp": "Row {{rowNumber}} in '{{fileName}}' is missing a valid timestamp_utc.",
    "rowOutside": "Row {{rowNumber}} in '{{fileName}}' has a {{header}} of {{value}}, outside [-{{limit}},{{limit}}].",
    "stoppageEventFileBytes": "Stoppage event file '{{fileName}}' is {{fileLength}} bytes, exceeding the {{maxFileSizeBytes}}-byte limit.",
    "stoppageEventFileEmpty": "Stoppage event file '{{fileName}}' is empty.",
    "stoppageEventFileExceeds": "Stoppage event file '{{fileName}}' exceeds the {{maxRowCount}}-row limit.",
    "stoppageEventFileMissing": "Stoppage event file is missing expected column header '{{header}}'.",
    "telemetryFileBytesExceeding": "Telemetry file '{{fileName}}' is {{fileLength}} bytes, exceeding the {{maxFileSizeBytes}}-byte limit.",
    "telemetryFileEmpty": "Telemetry file '{{fileName}}' is empty.",
    "telemetryFileExceedsRow": "Telemetry file '{{fileName}}' exceeds the {{maxRowCount}}-row limit.",
    "telemetryFileMissingExpected": "Telemetry file is missing expected column header '{{header}}'.",
    "unsupportedStoppageEventFile": "Unsupported stoppage event file '{{fileName}}'. Expected filename to contain legacyvendor.",
    "unsupportedTelemetryFileExpected": "Unsupported telemetry file '{{fileName}}'. Expected filename to contain genericfms or aftertrack."
  },
  "drillBlastSettings": {
    "groups": {
      "Units": "Units",
      "Drilling": "Drilling",
      "Blasting": "Blasting",
      "Explosives": "Explosives",
      "Consumables": "Consumables",
      "Survey": "Survey",
      "People": "People",
      "Blast record": "Blast record",
      "Magazine register": "Magazine register"
    },
    "settings": {
      "Units": {
        "BitSize": {
          "label": "Bit size unit",
          "description": "How bit sizes are shown. Stored in millimetres either way.",
          "choices": {
            "in": "in",
            "mm": "mm"
          }
        },
        "System": {
          "label": "Unit system",
          "description": "Metric or US units on screens and printed records. Stored metric either way.",
          "choices": {
            "Metric": "Metric",
            "US": "US"
          }
        }
      },
      "DefaultDrillingEntryMode": {
        "label": "Default drilling entry",
        "description": "Whether a new drilling session records summary lines or hole by hole.",
        "choices": {
          "Summary": "Summary",
          "Hole": "Hole"
        }
      },
      "Tolerances": {
        "DepthM": {
          "label": "Depth tolerance (m)",
          "description": "A hole further than this from its design depth is flagged short or over-depth."
        },
        "CollarM": {
          "label": "Collar tolerance (m)",
          "description": "An as-drilled collar further than this from its design position is flagged."
        },
        "ChargeLengthM": {
          "label": "Charge length tolerance (m)",
          "description": "A hole whose explosive column is further than this from its design length is flagged. 0 turns the check off."
        },
        "StemmingM": {
          "label": "Stemming tolerance (m)",
          "description": "A hole whose stemming is further than this from its design length is flagged; short stemming risks flyrock and airblast. 0 turns the check off."
        }
      },
      "Blast": {
        "DipMaxAgeHours": {
          "label": "Dip age limit (hours)",
          "description": "A hole charged against a dip older than this is flagged."
        },
        "MonitorLinkSeconds": {
          "label": "Monitor link window (seconds)",
          "description": "An imported monitor event within this many seconds of one firing is linked to it automatically."
        }
      },
      "Explosives": {
        "BulkVariancePercent": {
          "label": "Bulk variance allowed (%)",
          "description": "Bulk product reconciles if issued and charged agree within this percentage."
        },
        "LateEntryHours": {
          "label": "Late entry after (hours)",
          "description": "A register entry keyed this long after it happened is marked late."
        },
        "RegisterShiftHours": {
          "label": "Magazine shift (hours)",
          "description": "How the magazine keepers are rostered: 12 hours is a day and a night shift, 8 hours adds an afternoon. The register opens and closes each one.",
          "choices": {
            "12": "12",
            "8": "8"
          }
        }
      },
      "Consumables": {
        "ExpiryWarningDays": {
          "label": "Expiry warning (days)",
          "description": "Lots expiring within this many days are listed on the stock page."
        },
        "Valuation": {
          "label": "Stock valuation",
          "description": "FIFO or weighted average cost. Changing it alters reported values, so only a Lead Admin may.",
          "choices": {
            "FIFO": "FIFO",
            "WeightedAverage": "WeightedAverage"
          }
        }
      },
      "Survey": {
        "GridCrs": {
          "label": "Survey grid",
          "description": "The mine grid hole positions arrive in: an EPSG code such as EPSG:32647, or Local for control points."
        },
        "IredesPointX": {
          "label": "IREDES X axis",
          "description": "Which grid axis rigs read as X in IREDES drill plans and quality reports. Most rigs read the northing as X.",
          "choices": {
            "Northing": "Northing",
            "Easting": "Easting"
          }
        }
      }
    },
    "policies": {
      "R3": "Segregation and licensed NEQ",
      "R5": "No issue from an expired lot",
      "R6": "Reconciliation signed off before closing a pattern",
      "R7": "No open misfire when closing a pattern",
      "R8": "Shotfirer and receiver hold a current licence",
      "Firing": {
        "ShotfirerPersonId": "Shotfirer",
        "ExclusionZoneM": "Exclusion zone",
        "MicKg": "Maximum instantaneous charge",
        "NearestStructureM": "Distance to nearest structure",
        "Weather": "Weather",
        "CircuitTest": "Circuit test",
        "SentryCount": "Sentries posted"
      },
      "Register": {
        "IssuedToPersonId": "Person receiving an issue",
        "LotId": "Lot on lot-tracked products",
        "Reference": "Docket or certificate reference"
      }
    }
  }
}
